"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var tabs_1 = require("./tabs");
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return __importDefault(tabs_1).default; } });
